import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { StaticImage } from '../../../image'

import ProductPageVolumePricingModalIcon from './ProductPageVolumePricingModalIcon.svg'

export const ProductPageVolumePricingModalNotification: FC = () => {
  return (
    <div className="flex flex-row gap-2 rounded-xl bg-light-primary-low p-4">
      <span className="w-24">
        <StaticImage
          alt="volume pricing notification icon"
          src={ProductPageVolumePricingModalIcon}
        />
      </span>
      <div className="flex flex-col">
        <h3 className="mb-1 text-s font-medium text-dark-secondary-strong">
          <FormattedMessage id="volumePricing.modal.notification.title" />
        </h3>
        <span className="text-s font-normal">
          <FormattedMessage id="volumePricing.modal.notification.content" />
        </span>
      </div>
    </div>
  )
}
